import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User, UserState, Visit } from '@matap/shared';
import CacheStorage from '../cache/cache.storage';
import { actionLogOut } from './general.store';

const reducer = createSlice({
  name: 'user.reducer',
  initialState: {
    user: null as User,
    state: null as UserState,
    favoriteDoctors: [] as User[],
    cookies: null,
  },
  reducers: {
    actionSetUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
      CacheStorage.set('user-string', action.payload ? JSON.stringify(action.payload) : undefined);
    },
    actionSetUserState(state, action: PayloadAction<UserState>) {
      state.state = action.payload;
    },
    actionSetVisitSurvey(state, action: PayloadAction<Visit | undefined>) {
      state.state.pendingSurvey = action.payload;
    },
    actionSetFavoriteDoctors(state, action: PayloadAction<User[]>) {
      state.favoriteDoctors = action.payload;
      CacheStorage.set('favourite-doctors', JSON.stringify(action.payload));
    },
    actionSetCookies(state, action: PayloadAction<string>) {
      state.cookies = action.payload;
      CacheStorage.set('cookies', action.payload);
    },
  },
  extraReducers: (builder: any) => {
    builder.addCase(actionLogOut, (state) => {
      state.favoriteDoctors = [];
      state.user = null;
      state.state = null;
      CacheStorage.clear();
    });
  },
});

export const { actionSetUser, actionSetFavoriteDoctors, actionSetUserState, actionSetVisitSurvey, actionSetCookies } = reducer.actions;
export default reducer.reducer;
